var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"theme-toggle",class:{ 'dark-mode': _vm.isDarkMode },attrs:{"aria-label":"Toggle theme"},on:{"click":_vm.toggleTheme}},[_c('span',{staticClass:"theme-icon sun-icon"},[_vm._v("☀️")]),_vm._v(" "),_c('span',{staticClass:"theme-icon moon-icon"},[_vm._v("🌙")]),_vm._v(" "),_c('span',{staticClass:"theme-switch"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2994a67a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThemeToggle.vue
// module id = null
// module chunks = 